import { confirmChangeImpactsOnPlans } from "../edit/cropping/validate"
import { FieldViewModel, IOmniaShell } from "../omnia"
import { IFieldsService } from "../types"

export type SplitValidation = boolean | "delete" | "split"

export function validateSplit(cropping: FieldViewModel, shell: IOmniaShell, svc: IFieldsService): ng.IPromise<SplitValidation> {

    return validateLayerHandling(cropping, shell, svc)
        .then(res => res ? confirmNutritionDependencies(cropping, shell).then(ok => ok ? res : false) : false)
        .then(res => res ? confirmPlanDependencies(cropping, shell).then(ok => ok ? res : false) : false)

}

function confirmPlanDependencies(cropping: FieldViewModel, shell: IOmniaShell) {

    const crop = cropping.cropping

    if (crop.InNutritionPlan || crop.InSeedsPlan) {
        return confirmChangeImpactsOnPlans(shell)
    }

    return shell.resolve(true)

}

function confirmNutritionDependencies(cropping: FieldViewModel, shell: IOmniaShell) {

    if (cropping.cropping.HasNutritionRequirements) {

        const msg = `<p>The crop you are about to split already has nutrition requirements.</p>
                <p>You need to recalculate the requirements for these changes to be taken into account. Please note that the plans will also be recalculated as a consequence.</p>`

        const title = "Recalculate crop requirements"

        return omnia.shell.showOkCancel(shell, msg, title)

    }

    return shell.resolve(true)

}

export function validateLayerHandling(cropping: FieldViewModel, shell: IOmniaShell, svc: IFieldsService): ng.IPromise<SplitValidation> {

    if (!cropping.hasBoundary()) {
        return shell.resolve(true)
    }

    return svc.canDeleteCropping([cropping.croppingId]).then(depsArray => {

        const deps = depsArray[0]

        if (!(deps?.HasLayers)) {
            return true
        }

        return shell.showMessageBox({ templateUrl: "app/fields/split/layers.html" })

    })
}

